import { Table } from '@chakra-ui/react';
import { ComponentProps } from 'react';

type TdProps = ComponentProps<typeof Table.Cell>;

export const Td = (props: TdProps) => <Table.Cell py={5} {...props} />;
